"use strict";
import p from "./index.es144.js";
import q from "./index.es260.js";
import y from "./index.es261.js";
import E from "./index.es262.js";
import d from "./index.es147.js";
import v from "./index.es263.js";
import m from "./index.es264.js";
import A from "./index.es158.js";
const i = m.validators;
class w {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new y(),
      response: new y()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (s) {
      if (s instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? o && !String(s.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + o) : s.stack = o;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = d(this.defaults, t);
    const { transitional: s, paramsSerializer: a, headers: o } = t;
    s !== void 0 && m.assertOptions(s, {
      silentJSONParsing: i.transitional(i.boolean),
      forcedJSONParsing: i.transitional(i.boolean),
      clarifyTimeoutError: i.transitional(i.boolean)
    }, !1), a != null && (p.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : m.assertOptions(a, {
      encode: i.function,
      serialize: i.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), m.assertOptions(t, {
      baseUrl: i.spelling("baseURL"),
      withXsrfToken: i.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let k = o && p.merge(
      o.common,
      o[t.method]
    );
    o && p.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (r) => {
        delete o[r];
      }
    ), t.headers = A.concat(k, o);
    const h = [];
    let b = !0;
    this.interceptors.request.forEach(function(r) {
      typeof r.runWhen == "function" && r.runWhen(t) === !1 || (b = b && r.synchronous, h.unshift(r.fulfilled, r.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function(r) {
      f.push(r.fulfilled, r.rejected);
    });
    let l, n = 0, c;
    if (!b) {
      const r = [E.bind(this), void 0];
      for (r.unshift(...h), r.push(...f), c = r.length, l = Promise.resolve(t); n < c; )
        l = l.then(r[n++], r[n++]);
      return l;
    }
    c = h.length;
    let g = t;
    for (; n < c; ) {
      const r = h[n++], U = h[n++];
      try {
        g = r(g);
      } catch (S) {
        U.call(this, S);
        break;
      }
    }
    try {
      l = E.call(this, g);
    } catch (r) {
      return Promise.reject(r);
    }
    for (n = 0, c = f.length; n < c; )
      l = l.then(f[n++], f[n++]);
    return l;
  }
  getUri(e) {
    e = d(this.defaults, e);
    const t = v(e.baseURL, e.url, e.allowAbsoluteUrls);
    return q(t, e.params, e.paramsSerializer);
  }
}
p.forEach(["delete", "get", "head", "options"], function(u) {
  w.prototype[u] = function(e, t) {
    return this.request(d(t || {}, {
      method: u,
      url: e,
      data: (t || {}).data
    }));
  };
});
p.forEach(["post", "put", "patch"], function(u) {
  function e(t) {
    return function(s, a, o) {
      return this.request(d(o || {}, {
        method: u,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: a
      }));
    };
  }
  w.prototype[u] = e(), w.prototype[u + "Form"] = e(!0);
});
export {
  w as default
};
//# sourceMappingURL=index.es146.js.map
